import * as React from 'react'
import { RatingScaleLabel } from 'store/modules/checkins'

export type SkillChartsLegendProps = {
  noOfUsers: number
  title?: string
  labels?: RatingScaleLabel[]
}

export const SkillChartsLegend = (props: SkillChartsLegendProps) => {
  const { noOfUsers, title, labels } = props

  const requiredText =
    noOfUsers > 1 ? 'Average required skill level' : 'Required skill level'

  return (
    <div className="flex flex-col items-center">
      {title && (
        <h6 className="font-bold mb-5 text-gray-900 text-sm">{title}</h6>
      )}
      {labels && labels.length > 0 && (
        <div className="flex gap-5 mb-3">
          {[...labels]
            .sort((a, b) => a.scaleValue - b.scaleValue)
            .map((label) => (
              <div
                key={label.scaleValue}
                className="flex gap-1.5 items-center"
              >
                <div
                  className="bg-rating h-3 rounded-full w-3"
                  style={
                    { '--rating-color': label.color } as React.CSSProperties
                  }
                />
                <p className="mb-0 text-gray-600 text-xs">{label.labelName}</p>
              </div>
            ))}
        </div>
      )}
      <div>
        <div className="flex gap-1.5 items-center">
          <div className="bg-gray-200 h-3 rounded-full w-3"></div>
          <p className="mb-0 text-gray-600 text-xs">{requiredText}</p>
        </div>
      </div>
    </div>
  )
}
